import React, { useRef } from 'react'
import { useState } from 'react';
import { HideLoder, LogInUserID, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { ApiCmnHeadersPostCall } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';
import useConfig from '../../../Hooks/useConfig';

export default function AdminImportDevices() {
    const ImportDevicesFile = useRef();
    const { adminCallNode } = useConfig();
    const [loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [FileName, setFileName] = useState({
        error: '',
        document: '',
    });
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false
    });
    const [csvError, setCsvError] = useState("");

    async function ImportCSV(e) {
        setLoading(true)
        e.preventDefault();
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });
        const fileInput = ImportDevicesFile.current;
        const files = fileInput.files[0];
        if (!files) {
            setLoading(false)

            setFileName({ ...FileName, error: "First, import the CSV file.", document: "" });
            return;

        }
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setLoading(false);
            setFileName({ ...FileName, error: validationMsg, document: '' });
            fileInput.value = "";
            return;
        }

        var formdata = new FormData();
        formdata.append("file", files);
        formdata.append("userId", LogInUserID);

        try {
            const response = await ApiCmnHeadersPostCall(`${adminCallNode}/inventory/import`, formdata);
            const responseRs = JSON.parse(response);
            setLoading(false);
            if (responseRs.status === "success") {
                setNewAlerts(<AlertsComp show={true} variant="success" msg={'The CSV import process is running in the background. Once the import is completed, you will receive an email notification.'} />);
                setTimeout(function () {
                    setNewAlerts(<AlertsComp show={false} />);
                    fileInput.value = "";
                    setFileName({ ...FileName, error: '', document: '' });
                }, 1500);

            } else {
                setCsvError(responseRs);
                setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true });
                setFileName({ ...FileName, error: '', document: '' });
                fileInput.value = "";
            }
            fileInput.value = "";
            setFileName({ ...FileName, error: '', document: '' });
        } catch (error) {
            log.error('error', error);
            fileInput.value = "";
            setFileName({ ...FileName, error: '', document: '' });
        }
    }

    function ShowFileName() {
        const fileInput = ImportDevicesFile.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...FileName, error: validationMsg, document: '' });
            fileInput.value = "";
            return;
        }
        setFileName({ ...FileName, error: '', document: filename });
    }

    return (
        <React.Fragment>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Devices</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To ensure that Devices are entered properly with data accuracy, please download our CSV template file and ensure your columns match the template before you import your master inventory into the system.
                </p>
                <div className="row pt-3 px-3">
                    <label className="pb-4 ps-0" style={{ fontSize: "13px" }}>
                        <a onClick={() => downloadSampleCSV('adminDevices', 'inventory_admin')}
                            style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                            CLICK HERE
                        </a> {" "}
                        to download the template CSV file for master inventory data. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                    </label>
                    <div className="col-12">
                        <div className='d-flex gap-3 align-items-center'>
                            <form onSubmit={(e) => ImportCSV(e)}>
                                <input type="file" ref={ImportDevicesFile} name="upload_fileforimportdevices" id="UploadFileForImportDevices" accept='.csv' onChange={ShowFileName} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadFileForImportDevices"> Import Devices
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {FileName.document != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        <div className='col-md-12 pe-0'>
                            <div className=" ps-2" style={{ fontWeight: "600", color: FileName !== "First, import the CSV file." ? 'green' : 'red' }}>{FileName.document}</div>
                            {FileName.error?.trim() != "" && <label className='redText'>{FileName.error}</label>}
                        </div>
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />
        </React.Fragment>
    )
}
